import * as React from 'react';
import * as Styled from './styled';
import { Checkbox, Tooltip } from '@material-ui/core';
import ImmutableTimer from '../../api/immutables/ImmutableTimer';
import NarrativeField from 'components/NarrativeField';
import { FeaturesConsumer } from 'common/FeaturesProvider';
import { Features, TimerChunk } from '../../api/types/types';
import { InsertDriveFile } from '@material-ui/icons';
import { getTimerDurationTxt } from 'util/timer';
import { withTranslation } from 'react-i18next';
import { getUserLocale } from 'util/date';
import { inject, observer } from 'mobx-react';
import { RootStore } from 'store/root.store';
import EditTimerTimeDialogStore from 'store/Timer/edit.timer.time.dialog.store';

interface Props {
    timer: ImmutableTimer;
    onAddNote?: () => void;
    editTimerTimeDialogStore?: EditTimerTimeDialogStore;
    // tslint:disable-next-line:no-any
    t: any;
}
interface RunningTimerChunkState {
    durTxt: string;
}

// Map the store identically to how TimerChunkItem does it
@inject((allStores: { rootStore: RootStore }) => {
    return {
        editTimerTimeDialogStore: allStores.rootStore.editTimerChunkTimeDialogStore
    }
})

@observer
class RunningTimerChunkItem extends React.Component<Props, RunningTimerChunkState> {
    interval: NodeJS.Timeout;

    constructor(props: Props) {
        super(props);
        this.state = { durTxt: '' };
        this.interval = setInterval(this.timerTick, 250);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    onClickNarrative = () => {
        if (this.props.onAddNote) {
            this.props.onAddNote();
        }
    }
    timerTick = () => {
        this.setState({ durTxt: getTimerDurationTxt(this.props.timer, undefined, true) });
    }
    onChangeDummy = () => {
        // do nothing on change
    }
    handleClick = async (e: React.KeyboardEvent | React.MouseEvent, id: number) => {
        const store = this.props.editTimerTimeDialogStore!;
        const { currentTimekeeper, online, setPreviousActiveElement } = store.rootStore.appStore;
        
        if ('key' in e && (e.key !== 'Enter' && e.key !== ' ') || 
            !currentTimekeeper.writable ||
            (online && id < 0)
        ) {
            return;
        }

        if (id) {
            setPreviousActiveElement();

            const simulatedSegment: TimerChunk & { isRunningTimer?: boolean } = {
                id: this.props.timer.id!,
                timerId: this.props.timer.id!,
                startTime: this.props.timer.startedOn!,
                endTime: new Date().toISOString(), 
                description: this.props.timer.notes || '',
                submitted: false,
                deleted: false,
                used: false,     
                timeEntryId: undefined,
                isRunningTimer: true
            }; 

            await store.open(simulatedSegment).catch(() => null);
        }
    }
    render() {
        const { timer, onAddNote, t } = this.props;
        const locale = getUserLocale();
        const timerId = timer.id!;
        const startTime = new Date(timer.lastActive).toLocaleTimeString();
        return (
            <FeaturesConsumer>
                {(features: Features) =>
                <div style={{ height: 80 }}>
                    <Styled.SegmentPaper submitted={false} hasEntry={false}>
                        <Styled.Control>
                            <Checkbox
                                onClick={(e) => e.stopPropagation()}
                                disableRipple={true}
                                style={{padding: 0}}
                                disabled={true}
                            />
                        </Styled.Control>
                        <Styled.DateContainer>
                            {(new Date(timer.startedOn!)).toLocaleDateString(locale,
                                {year: 'numeric', month: '2-digit', day: '2-digit'})}
                        </Styled.DateContainer>
                        <Tooltip title={t('selected_timer.chunk.field.duration.tooltip.startTime', { startTime })}>
                            <Styled.TimeContainer
                                tabIndex={0}
                                aria-label={t('selected_timer.chunk.field.duration.aria_label', { duration: this.state.durTxt })}
                                onClick={(evt) => this.handleClick(evt, timerId)}
                                onKeyDown={(evt) => this.handleClick(evt, timerId)}
                                style={{ cursor: 'pointer' }}
                            >
                                {this.state.durTxt}
                            </Styled.TimeContainer>
                        </Tooltip>
                        <Styled.NarrativeContainer>
                            <div onClick={this.onClickNarrative} style={{width: '100%'}}>
                                <NarrativeField
                                    onChange={this.onChangeDummy}
                                    value={timer.notes!}
                                    placeholder={t('active_chunk.field.narrative.placeholder')}
                                    maxLength={features.EpochConfigNarrativesMaximumChars}
                                    disabled={true}
                                    style={{maxHeight: 52}}
                                />
                            </div>
                        </Styled.NarrativeContainer>
                        <Styled.RunningItemActionContainer>
                            <Styled.CompactIconButton onClick={onAddNote} title={t('active_chunk.icon.tooltip')}>
                                <InsertDriveFile fontSize="small" />
                            </Styled.CompactIconButton>
                        </Styled.RunningItemActionContainer>
                    </Styled.SegmentPaper>
                </div>
                }
            </FeaturesConsumer>
        )
    }
}

export default withTranslation(['timers'])(RunningTimerChunkItem);